<template>
  <div class="venue-data-list">
    <a-table :scroll="{ x: 1200 }" :columns="columns" :data-source="tableData" :pagination="pagination" :loading="loading" row-key="id" @change="handleTableChange">
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="venueStatus[record.status]" :color="venueStatus[record.status].color">
          {{ venueStatus[record.status].label }}
        </a-tag>
        <span v-else>--</span>
      </template>

      <template slot="activity" slot-scope="text, record">
        <a-tag v-if="venueActivity[record.activity]" :color="venueActivity[record.activity].color">
          {{ venueActivity[record.activity].label }}
        </a-tag>
        <span v-else>--</span>
      </template>

      <template slot="name" slot-scope="name, record">
        <a class="custom-link" target="_blank" :href="venueDetailUrl(record)">{{ record.name }}</a>
      </template>

      <template slot="creator" slot-scope="creator">
        <user-profiles :value="[creator]" avatar />
      </template>

      <template slot="products" slot-scope="text, record">
        <a-tag color="blue">{{ record.products.length || 0 }}</a-tag>
      </template>

      <template slot="participants" slot-scope="text, record">
        <a-tag color="blue">{{ record.participants.length || 0 }}</a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <a v-dis="{ code: 'business:venue:edit' }" :disabled="record.status !== 1" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a v-dis="{ code: 'business:venue:edit' }" @click="handleDelete(record)">删除</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import UserProfiles from '@/components/User/Profiles';
import dayjs from 'dayjs';
import { venueStatus, venueActivity } from '@/utils/venueConstants';

export default {
  name: 'VenueDataList',
  components: {
    UserProfiles
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      venueActivity,
      venueStatus,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 80
        },
        {
          title: '会场名称',
          dataIndex: 'name',
          key: 'name',
          width: 300,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '会场状态',
          dataIndex: 'status',
          key: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '开始时间',
          dataIndex: 'start_time',
          key: 'start_time',
          width: 180
        },
        {
          title: '会场类型',
          dataIndex: 'activity',
          key: 'activity',
          width: 120,
          scopedSlots: { customRender: 'activity' }
        },
        {
          title: '需求数',
          dataIndex: 'products',
          key: 'products',
          width: 100,
          scopedSlots: { customRender: 'products' }
        },
        {
          title: '参与团队数',
          dataIndex: 'participants',
          key: 'participants',
          width: 110,
          scopedSlots: { customRender: 'participants' }
        },
        {
          title: '创建人',
          dataIndex: 'creator',
          key: 'creator',
          width: 100,
          scopedSlots: { customRender: 'creator' }
        },
        {
          title: '创建时间',
          dataIndex: 'created_time',
          key: 'created_time',
          width: 180
        },
        {
          title: '更新时间',
          dataIndex: 'updated_time',
          key: 'updated_time',
          width: 180
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },

  computed: {
    venueDetailUrl() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:venue:detail',
          params: { id: record.id }
        }).href;
      };
    }
  },
  methods: {
    formatDateTime(time) {
      return time ? dayjs(time).format('YYYY-MM-DD HH:mm') : '-';
    },

    handleEdit(record) {
      this.$emit('edit', record);
    },

    handleDelete(record) {
      this.$emit('delete', record);
    },

    handleTableChange(pagination, filters, sorter) {
      this.$emit('page-change', pagination);
    },

    handleViewDetail(record) {
      // 跳转到会场详情页面
      this.$router.push({
        name: 'page:business:venue:detail',
        params: { id: record.id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.venue-data-list {
  :deep(.ant-table) {
    .ant-table-tbody > tr > td {
      padding: 12px 16px;
    }
  }

  .name-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .venue-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 8px;
    }

    .detail-link {
      padding: 0;
      height: auto;
      line-height: 1;
    }
  }
}
</style>
